import PropTypes from 'prop-types';
import React from 'react';
import _Empty from 'lodash/isEmpty';
import cn from 'classname';
import { Field, reduxForm } from 'redux-form';
import _debounce from 'lodash/debounce';
import './main.less';

import ModalBox from '../../../shared/modal';
import SelectField from '../../../shared/form-elements/select/field';
import Input from '../../../shared/form-elements/input';
import Calendar from '../../../shared/calendar/main';

const Form = props => {
	const submit = data => props.requestGarantFormSubmit(data);
	const { fetchOffersGarantApproveData } = props;
	const { target_approve, offers, countries } = props.requestGarantFormOfferApproveData || {};

	return (
		<div className='payouts-transaction-form-wrap payouts-form-in-modal'>
			<form
				className='ui-form payouts-form__main clearfix'
				onSubmit={props.handleSubmit(submit)}
			>
				<div className="ui-control-bar__item-position">
					<Calendar
						{...props.garantRequestCalendar}
						onInit={props.garantRequestCalendarInit}
						onToggle={props.garantRequestCalendarToggle}
						onChange={data => {
							props.garantRequestCalendarChange(data);
							setTimeout(fetchOffersGarantApproveData, 1500);
						}}
						onApply={props.garantRequestCalendarApply}
						intl={props.intl}

					/>
				</div>
				<div className="manual-approve__element ui-form__element">
					<Field
						name="offers"
						placeholder={'Offer'}
						multi={false}
						searchable={true}
						options={props.offersGarantLookup}
						component={SelectField}
						showLabel={false}
						onChange={() => {
							setTimeout(fetchOffersGarantApproveData, 500);
						}}
					/>
				</div>
				<div className="manual-approve__element ui-form__element">
					<Field
						name="countries"
						placeholder={props.intl('Country')}
						multi={false}
						searchable={true}
						options={props.approveGarantLocationsLookups.bind(null, false)}
						component={SelectField}
						showLabel={false}
						onChange={() => {
							setTimeout(fetchOffersGarantApproveData, 500);
						}}
					/>
				</div>
				<div className="manual-approve__element ui-form__element">
					<Field
						name="sid"
						placeholder={props.intl('Sid 1, 2, 3, 4 or 5 (optional)')}
						component={Input}
						showLabel={false}
						onChange={_debounce(fetchOffersGarantApproveData, 500) }
					/>
				</div>
				<div className="manual-approve__element ui-form__element">
					<Field
						name="campaign_ids"
						placeholder={'Campaign'}
						multi={false}
						searchable={true}
						options={props.campaignsGarantLookup}
						component={SelectField}
						showLabel={false}
						onChange={() => {
							setTimeout(fetchOffersGarantApproveData, 500);
						}}
					/>
				</div>
				<div className="manual-approve__element ui-form__element">
					<Field
						name="target_approve"
						placeholder={props.intl('Target approve') + ', %'}
						type="number"
						normalize={
							(value, oldValue) => {
								if (!Number(value)) {
									return '';
								}
								return Number(value) >= 0 && Number(value) <= 100 ? Number(value) : oldValue;
							}
						}
						component={Input}
						showLabel={false}
						onChange={_debounce(fetchOffersGarantApproveData, 500) }
					/>
				</div>
				<div className="manual-approve__element ui-form__element">
					<Field
						name="comment"
						placeholder={props.intl('Comment')}
						component={Input}
						showLabel={false}
					/>
				</div>
				<div className="margin-bottom-10">{
					props.requestGarantFormOfferApproveData
					&& props.requestGarantFormOfferApproveData.map((row, index) =>
						<div className="margin-bottom-10" key={index}>
							<p className="info-row">
								Offer: {row.offer_title}. Total Leads {row.total_count} / Valid Leads {row.valid_count}
							</p>
							{
								row.has_leads
								&& <p>
									Current approve is {row.approval_percent}%. To increase it to
									{` ${row.target_approve}%`} need approve {row.rejected_to_approve} rejected
									leads + {row.trash_to_approve || 0} trash leads + {row.pending_to_approve || 0} pending leads =
									{
										Object.keys(row.toBePayed)
											.filter(key => row.toBePayed[key] > 0)
											.map(key => `${row.toBePayed[key]} ${key.toUpperCase()} `)
											.join(';')
									}
									will be issued to affiliate. Approve after increasing
									{` ${Math.floor(row.approve_after_increasing * 100)/100}%`}
								</p>
							}
						</div>
					)}
				{
					_Empty(props.requestGarantFormOfferApproveData)
					&& !!target_approve && !!offers && !!countries
					&& 'Nothing found'
				}
				</div>
				<button
					className={cn({
						'ui-btn': true,
						'ui-btn-primary apply': !props.isBlockedRequestGarantSubmitButton,
						'ui-btn-cancel cancel': props.isBlockedRequestGarantSubmitButton
					})}
					type='submit'
					disabled={props.isBlockedRequestGarantSubmitButton}
				>{props.intl('Apply')}</button>
				<button
					className='ui-btn ui-btn-cancel cancel'
					onClick={e => {
						e.preventDefault();
						props.toggleIncreaseApproveForm();
					}}
				>{props.intl('Cancel')}</button>
			</form>
		</div>
	);
};

Form.propTypes = {
	intl: PropTypes.func
};

const Main = props =>
	<ModalBox
		title={props.intl('Request garant')}
		body={Form(props)}
		isOpen={props.isRequestGarantFormVisible}
		onClose={props.toggleRequestGarantForm}
		className='form-modal increase-payout-modal'
	/>;

Main.propTypes = {
	intl: PropTypes.func
};

export default formName => reduxForm({ form: 'affiliateProfileRequestGarantForm' })(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/request-garant-form/main.js